<template>
  <div class="m_home">
    <MobilePageBanner
      :background-image="require('@/assets/images/mobile/home/banner@2x.png')"
      :slogans="['创宇业务安全解决方案，', '为您一站解决互联网业务风险']"
      button-href="https://www.yunaq.com/activity/activityform?name=业务安全"
    ></MobilePageBanner>
    <div class="m_des">
      为互联网平台提供认证体系搭建咨询和实施服务，从准入规则、认证分级、验证流程到结果应用，解决互联网平台上的违规虚假、品牌仿冒、用户欺诈的问题，净化平台服务和交易环境。
    </div>
    <MobileTabView :tabs="tabs">
      <template v-slot:panel="{ panel }">
        <div v-if="panel.value === 'auth'" class="m_panel">
          <div class="m_title">互联网认证</div>
          <div class="m_des_item">
            为互联网平台企业&机构认证提供体系搭建咨询和实施服务，从准入规则、认证分级、验证流程到结果展示。
          </div>
          <div class="m_des_item Mb24">
            闭环解决互联网平台上的虚假违规用户、仿冒用户、欺诈用户的问题，确保认证后的用户的真实合规性。
          </div>
          <div class="Tac Mb24">
            <div class="m_btn" @click="$router.push({ name: 'AptitudeSafe' })">
              了解更多
            </div>
          </div>
          <img src="@/assets/images/mobile/home/section1@2x.png" alt="" />
        </div>
        <div
          v-if="panel.value === 'content'"
          class="m_panel"
          style="background: #f7f9fc"
        >
          <div class="m_title">内容安全</div>
          <div class="m_des_item">
            为互联网内容平台提供内容安全体系搭建咨询和实施服务。
          </div>
          <div class="m_des_item Mb24">
            从内容安全规则、恶意分级、过滤流程、应急机制等环节，拦截互联网平台上的违规涉政、涉黄、涉恐等信息，确保互联网平台的稳定运营。
          </div>
          <div class="Tac Mb24">
            <a class="m_btn" href="http://hjws.yunaq.com/">了解更多</a>
          </div>
          <img src="@/assets/images/mobile/home/section2@2x.png" alt="" />
        </div>
        <div v-if="panel.value === 'audit'" class="m_panel">
          <div class="m_title">审核平台</div>
          <div class="m_des_item">
            为互联网平台企业&机构认证 提供体系搭建咨询和实施服务。
          </div>
          <div class="m_des_item Mb24">
            从准入规则、认证分级、为企业或相关监管机构提供SaaS模式和私有化部署的标准化审核平台产品。
          </div>
          <div class="m_des_item Mb24">
            该平台可同时支持：文本、图像、视频、图文、音频的审核；同时具备角色定义、多规则定义、多审核模式定义、运营看板等功能，可轻松满足百人同时在线作业。
          </div>
          <div class="Tac Mb24">
            <div class="m_btn" @click="$router.push({ name: 'AuditPlatform' })">
              了解更多
            </div>
          </div>
          <img src="@/assets/images/mobile/home/section3@2x.png" alt="" />
        </div>
      </template>
    </MobileTabView>
    <div class="m_panel" style="background: #f7f9fc">
      <div class="m_title">合作客户</div>
      <img src="@/assets/images/mobile/home/partners@2x.png" alt="" />
    </div>
  </div>
</template>

<script>
import MobilePageBanner from '@/components/mobile/MobilePageBanner'
import MobileTabView from '@/components/mobile/MobileTabView'

export default {
  name: 'MobileHome',
  components: {
    MobilePageBanner,
    MobileTabView,
  },
  data() {
    return {
      tabs: [
        {
          label: '互联网认证',
          value: 'auth',
        },
        {
          label: '内容安全',
          value: 'content',
        },
        {
          label: '审核平台',
          value: 'audit',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.m_home {
  text-align: start;
  .m_title {
    margin-bottom: 16px;
  }
}
</style>
